import { RealtyCity, RealtySource } from 'shared/api/kyrgyzstan/search/model'

export const getLocationTitle = (
  city: RealtyCity,
  address: string,
  source: RealtySource,
) => {
  if (source === RealtySource.INTERNAL) {
    return `${city.city_name}, ${Boolean(city?.region) ? `${city.region}, ` : ''} ${address}`
  }
  return address
}
